var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2987 5.70971C18.1119 5.52246 17.8583 5.41723 17.5938 5.41723C17.3292 5.41723 17.0756 5.52246 16.8888 5.70971L11.9988 10.5897L7.10875 5.69971C6.92192 5.51246 6.66827 5.40723 6.40375 5.40723C6.13923 5.40723 5.88558 5.51246 5.69875 5.69971C5.30875 6.08971 5.30875 6.71971 5.69875 7.10971L10.5887 11.9997L5.69875 16.8897C5.30875 17.2797 5.30875 17.9097 5.69875 18.2997C6.08875 18.6897 6.71875 18.6897 7.10875 18.2997L11.9988 13.4097L16.8888 18.2997C17.2788 18.6897 17.9087 18.6897 18.2987 18.2997C18.6888 17.9097 18.6888 17.2797 18.2987 16.8897L13.4087 11.9997L18.2987 7.10971C18.6788 6.72971 18.6788 6.08971 18.2987 5.70971Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#808B99"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.5cb20025a8a1be4cbe51a949cbdea230.svg";
export { ForwardRef as ReactComponent };